import { combineReducers } from "redux"

import theme from "./slices/themeSlice"
import doctorSubscription from "./slices/doctorSubscriptionSlice"
import doctor from "./slices/doctorSlice"
import blogSlice  from "./slices/blogSlice"
import auth from "./slices/authSlice"
import ambassador from "./slices/ambassadorSlice"
import admin from "./slices/adminSlice"
const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    admin,
    ambassador,
    auth,
    blog: blogSlice,
    doctor,
    doctorSubscription,
    theme,
    ...asyncReducers,
  })
  return combinedReducer(state, action)
}

export default rootReducer
